/* @flow */

export const FETCH_CONVERSATION_REQUEST = 'FETCH_CONVERSATION_REQUEST';
export const FETCH_CONVERSATION_SUCCESS = 'FETCH_CONVERSATION_SUCCESS';
export const FETCH_CONVERSATION_FAILURE = 'FETCH_CONVERSATION_FAILURE';

export const CREATE_CONVERSATION_REQUEST = 'CREATE_CONVERSATION_REQUEST';
export const CREATE_CONVERSATION_SUCCESS = 'CREATE_CONVERSATION_SUCCESS';
export const CREATE_CONVERSATION_FAILURE = 'CREATE_CONVERSATION_FAILURE';

export const FETCH_CONVERSATION_ACTIONS_REQUEST =
  'FETCH_CONVERSATION_ACTIONS_REQUEST';
export const FETCH_CONVERSATION_ACTIONS_SUCCESS =
  'FETCH_CONVERSATION_ACTIONS_SUCCESS';
export const FETCH_CONVERSATION_ACTIONS_FAILURE =
  'FETCH_CONVERSATION_ACTIONS_FAILURE';

export const REPLY_TO_CONVERSATION_REQUEST = 'REPLY_TO_CONVERSATION_REQUEST';
export const REPLY_TO_CONVERSATION_SUCCESS = 'REPLY_TO_CONVERSATION_SUCCESS';
export const REPLY_TO_CONVERSATION_FAILURE = 'REPLY_TO_CONVERSATION_FAILURE';

export const MARK_CONVERSATION_AS_READ_REQUEST =
  'MARK_CONVERSATION_AS_READ_REQUEST';
export const MARK_CONVERSATION_AS_READ_SUCCESS =
  'MARK_CONVERSATION_AS_READ_SUCCESS';
export const MARK_CONVERSATION_AS_READ_FAILURE =
  'MARK_CONVERSATION_AS_READ_FAILURE';

export const INCREMENT_CONVERSATION_UNREAD_MESSAGE =
  'INCREMENT_CONVERSATION_UNREAD_MESSAGE';

export const RECEIVE_MESSAGE = 'RECEIVE_MESSAGE';

export const REMOVE_CONVERSATION_FROM_TOPIC = 'REMOVE_CONVERSATION_FROM_TOPIC';
